import { render, staticRenderFns } from "./HeadScreen.vue?vue&type=template&id=014c389a&scoped=true&"
import script from "./HeadScreen.vue?vue&type=script&lang=js&"
export * from "./HeadScreen.vue?vue&type=script&lang=js&"
import style0 from "./HeadScreen.vue?vue&type=style&index=0&id=014c389a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014c389a",
  null
  
)

export default component.exports